/**
 * ════════════════════════════════════════════════════════════════════
 *  KINGZ UK (kingz-uk.myshopify.com) — PHASE 3/4 DEFERRED THIRD-PARTY JS
 *  File: assets/kingz-defer-scripts.js
 *  Deployed: July 2026
 *  Impact: Removes render-blocking / main-thread work of GTM + Order
 *          Protection from the critical path. They now load on the first
 *          real user interaction (or after a 5s fallback).
 *  Risk:   Low — both fire well before checkout; dataLayer is preserved.
 * ════════════════════════════════════════════════════════════════════
 *
 *  This mirrors the US store's Phase 3.9 GTM deferral, adapted to the UK
 *  (District) theme. It ONLY defers scripts that live in theme code and
 *  whose IDs are already present in layout/theme.liquid — nothing is
 *  guessed and no Shopify Admin app-embed toggle is required.
 *
*  Deferred here:
 *    GTM injection handled by Stape app embed
 *    • Order Protection widget
 * ════════════════════════════════════════════════════════════════════
 */
(function () {
  'use strict';

  var FALLBACK_MS = 5000;
  var fired = false;

  // Keep dataLayer available immediately so any early pushes are queued.
  window.dataLayer = window.dataLayer || [];


  function loadOrderProtection() {
    if (window.__kingzOPLoaded) return;
    window.__kingzOPLoaded = true;
    var s = document.createElement('script');
    s.src = 'https://cdn.orderprotection.com/widget/shopify/5.28.45/orderprotection.js';
    s.async = true;
    s.onload = function () {
      try {
        if (typeof OrderProtection === 'undefined') return;
        var widget = OrderProtection.createOrderProtectionWidget({
          debug: false,
          locations: [{
            sibling: {
              position: 'after',
              selector: '.order-protection',
              styles: { 'text-align': 'left' }
            }
          }]
        });
        widget.addPlugin(OrderProtection.overrideFetchPlugin());
        widget.init();
        console.log('[Kingz UK] Order Protection widget loaded after interaction/timeout.');
      } catch (e) {
        console.warn('[Kingz UK] Order Protection init failed:', e);
      }
    };
    document.head.appendChild(s);
  }

  function loadAll() {
    if (fired) return;
    fired = true;
    loadOrderProtection();
    cleanup();
  }

  var EVENTS = ['mousemove', 'mousedown', 'touchstart', 'keydown', 'scroll', 'click', 'wheel'];
  function cleanup() {
    EVENTS.forEach(function (evt) {
      window.removeEventListener(evt, loadAll, { passive: true });
    });
  }
  EVENTS.forEach(function (evt) {
    window.addEventListener(evt, loadAll, { passive: true });
  });

  // Fallback so tags/analytics still fire for bounce/no-interaction sessions.
  setTimeout(loadAll, FALLBACK_MS);
})();
